import * as Yup from "yup";

const currentYear = new Date().getFullYear();

const validationSchema = Yup.object({

  title: Yup.string()
    .required("نام خودرو را وارد کنید")
    .min(2, "نام خودرو حداقل ۲ کاراکتر باشد")
    .max(50, "نام خودرو حداکثر ۵۰ کاراکتر باشد"),

  company: Yup.string()
    .nullable()
    .max(25, "نام شرکت حداکثر 25 کاراکتر باشد"),

  productYear: Yup.number()
    .typeError("سال ساخت را وارد کنید")
    .required("سال ساخت را وارد کنید")
    .min(1300, "سال ساخت معتبر نیست")
    .max(currentYear + 1, "سال ساخت معتبر نیست"),

  shasiNo: Yup.string()
    .nullable()
    .max(50, "شماره شاسی حداکثر ۵۰ کاراکتر باشد"),

  kilometer: Yup.number()
    .typeError("کارکرد خودرو را وارد کنید")
    .required("کارکرد خودرو را وارد کنید")
    .min(0, "مقدار نامعتبر است")
    .max(9999999, 'بیشتر از 7 رقم مجاز نیست'),

  distancePerWeek: Yup.number()
    .typeError("کارکرد هفتگی را وارد کنید")
    .required("کارکرد هفتگی را وارد کنید")
    .min(7, "مقدار نامعتبر است")
    .max(7000,'بیشتر از 7000 کیلومتر مجاز به تعریف نیستید'),

  useFuel: Yup.number()
    .typeError("مصرف سوخت را وارد کنید")
    .required("مصرف سوخت را وارد کنید")
    .min(1, "مقدار نامعتبر است")
    .max(999,'بیشتر از 3 رقم مجاز نیست'),

  pelak1: Yup.number()
    .typeError("بخش اول پلاک را وارد کنید")
    .required("بخش اول پلاک را وارد کنید")
    .min(10, 'کمتر از 2 رقم مجاز نیست')
    .max(99, 'بیشتر از 2 رقم مجاز نیست'),

  pelak2: Yup.number()
    .typeError("حرف پلاک را وارد کنید")
    .required("حرف پلاک را وارد کنید"),

  pelak3: Yup.number()
    .typeError("بخش دوم پلاک را وارد کنید")
    .required("بخش دوم پلاک را وارد کنید")
    .min(100, 'کمتر از 3 رقم مجاز نیست')
    .max(999, 'بیشتر از 3 رقم مجاز نیست'),

  pelak4: Yup.number()
    .typeError("کد ایران را وارد کنید")
    .required("کد ایران را وارد کنید")
    .min(10, 'کمتر از 2 رقم مجاز نیست')
    .max(99, 'بیشتر از 2 رقم مجاز نیست'),

  imageFile: Yup.mixed().nullable(),

});

export default validationSchema;

